import type { ComicItem } from "@/mocks/comics";

interface ComicCardProps {
  comic: ComicItem;
  size?: "default" | "small";
}

export default function ComicCard({ comic, size = "default" }: ComicCardProps) {
  return (
    <a
      href="#每日精选"
      className="group flex h-full cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200 bg-background-100 transition-colors duration-300 hover:border-background-300"
      aria-label={`${comic.title} 漫画推荐`}
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden bg-background-200">
        <img
          src={comic.cover}
          alt={`${comic.title} ${comic.genre}漫画封面`}
          title={`${comic.title} ${comic.genre}漫画推荐`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-2.5 py-1 text-xs font-medium text-foreground-800 backdrop-blur">
          {comic.genre}
        </span>
        <span className="absolute right-3 top-3 flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-xs font-bold text-background-50">
          {comic.rating}
        </span>
      </div>
      <div className="flex flex-1 flex-col gap-2 p-4 md:p-5">
        <div className="flex items-center justify-between gap-2">
          <h3 className="text-sm font-bold text-foreground-950 md:text-base">{comic.title}</h3>
          <span className="whitespace-nowrap text-xs text-foreground-500">{comic.author}</span>
        </div>
        <div className="flex flex-wrap gap-1.5">
          {comic.tags.map((tag) => (
            <span
              key={tag}
              className="rounded-md bg-secondary-100 px-2 py-0.5 text-xs text-secondary-800"
            >
              {tag}
            </span>
          ))}
        </div>
        <p
          className={`text-xs leading-relaxed text-foreground-600 md:text-sm ${
            size === "small" ? "line-clamp-2" : "line-clamp-3"
          }`}
        >
          {comic.summary}
        </p>
        <p className="mt-auto border-t border-background-200 pt-2 text-xs text-primary-700">
          <span className="mr-1">编辑说</span>·{comic.note}
        </p>
      </div>
    </a>
  );
}